// extracted by mini-css-extract-plugin
export var button = "styles-module--button--1ArDi";
export var locales = "styles-module--locales--1hIao";
export var selectedLng = "styles-module--selectedLng--3O2PU";